'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.add = add;
exports.get = get;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 Tulir Asokan <tulir@maunium.net>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var REACTION_COUNT = JSON.parse(window.localStorage.mx_reaction_count || '{}');
var sorted = null;

function add(emoji) {
    var _ref = REACTION_COUNT[emoji] || [0],
        _ref2 = (0, _slicedToArray3.default)(_ref, 1),
        count = _ref2[0];

    REACTION_COUNT[emoji] = [count + 1, Date.now()];
    window.localStorage.mx_reaction_count = (0, _stringify2.default)(REACTION_COUNT);
    sorted = null;
}

function get() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 24;

    if (sorted === null) {
        sorted = (0, _entries2.default)(REACTION_COUNT).sort(function (_ref3, _ref4) {
            var _ref6 = (0, _slicedToArray3.default)(_ref3, 2),
                _ref6$ = (0, _slicedToArray3.default)(_ref6[1], 2),
                count1 = _ref6$[0],
                date1 = _ref6$[1];

            var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
                _ref5$ = (0, _slicedToArray3.default)(_ref5[1], 2),
                count2 = _ref5$[0],
                date2 = _ref5$[1];

            return count2 === count1 ? date2 - date1 : count2 - count1;
        }).map(function (_ref7) {
            var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
                emoji = _ref8[0],
                count = _ref8[1];

            return emoji;
        });
    }
    return sorted.slice(0, limit);
}
//# sourceMappingURL=recent.js.map